if (!window.customElements.get('slider-reviews')) {
  class SliderReviews extends HTMLElement {
    constructor() {
      super();
      this.settings = {
        slidesToShow: parseInt(this.dataset.slides || 4),
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows: true,
        responsive: [
          { /* mobile/tablet */
            breakpoint: 1023,
            settings: {
              arrows: false,
              variableWidth: true,
              slidesToShow: 1
            }                             
          }
        ]
      }
    }

    initSlider () {
      this.$slider = $(this).slick(this.settings);
    }

    connectedCallback() {
      this.initSlider();
    }
  }

  window.customElements.define('slider-reviews', SliderReviews);
}
